const signedDefaultPermissions = [
    {
        link: '/dashboard'
    },
    {
        link: '/dashboard_empresa'
    },
    {
        link: '/dados_cadastrais'
    },
    {
        link: '/grupo_permissoes/:grupoId'
    },
    {
        link: '/perfil'
    },
    {
        link: '/acesso'
    },
    {
        link: '/not_allowed'
    },
    {
        link: '/relatorio/:grupoId'
    },
    {
        link: '/gerenciar/:entidade'
    },
    {
        link: '/evento/:id'
    },
    {
        link: '/enquete/:id/votar'
    },
    {
        link: '/enquete/:id/feedback'
    },
    {
        link: '/enquete/:id/respostas'
    },
    {
        link: '/enquete/participacao'
    },
    {
        link: '/dashboard/prontuario'
    },
    {
        link: '/dashboard/prontuario/tag/:pessoa_id'
    },
    {
        link: '/auth/feature/:id'
    },
    {
        link: '/auth/checkout'
    },
    {
        link: '/auth/produtos'
    },
    {
        link: '/auth/produtos/prontuario'
    },
    {
        link: '/assinaturas'
    },
    {
        link: '/formas-pagamento'
    },
    {
        link: '/familia'
    },
    {
        link: '/emergencia/acessos'
    },
    {
        link: '/admin'
    },
    {
        link: '/admin/assinaturas'
    },
    {
        link: '/admin/faturas'
    },
    {
        link: '/admin/acessos'
    },
    {
        link: '/admin/gratuidades'
    },
    {
        link: '/prontuario/membro'
    },
    {
        link: '/plano/upgrade/:plano_atual/:plano_sugerido'
    },
    {
        link: '/auth/membro_familia/consentimento/:token'
    },
    {
        link: '/assinaturas/alterar_plano'
    },
    {
        link: '/quem-somos'
    },
    {
        link: '/contatos'
    },
    {
        link: '/termos-de-uso'
    },
    {
        link: '/politica-privacidade'
    },
    {
        link: '/politica-reembolso'
    },
    {
        link: '/agenda'
    },
    {
        link: '/agenda/evento/:id'
    },
    {
        link: '/contratacao/gratis/:id'
    }
]

const unsignedDefaultPermissions = [
    {
        link: '/'
    },
    {
        link: '/login',
    },
    {
        link: '/signup'
    },
    {
        link: '/not_allowed'
    },
    {
        link: '/pass_recover'
    },
    {
        link: '/pass_recover/:token'
    },
    {
        link: '/compra_cartao'
    },
    {
        link: '/evento/:id/:pessoa_id'
    },
    {
        link: '/evento/:id/painel'
    },
    {
        link: '/quem-somos'
    },
    {
        link: '/contatos'
    },
    {
        link: '/termos-de-uso'
    },
    {
        link: '/politica-privacidade'
    },
    {
        link: '/politica-reembolso'
    },
    {
        link: '/fatura_paga'
    },
    {
        link: '/feature/:id'
    }, 
    {
        link: '/checkout'
    },
    {
        link: '/usuario/confirmacao/:token'
    },
    {
        link: '/emergencia/:token'
    },
    {
        link: '/emergencia/:token/shared/:qrcode_token'
    },
    {
        link: '/produtos/prontuario'
    },
    {
        link: '/produtos/prontuario/comercial'
    },
    {
        link: '/usuario/email_alteracao/confirmacao/:token'
    },
    {
        link: '/membro_familia/consentimento/:token'
    },
    {
        link: '/choice'
    },
    {
        link: '/confirmacao_conta'
    },
    {
        link: '/plano/:id'
    }
]

export {
    unsignedDefaultPermissions,
    signedDefaultPermissions
}
